import { render, staticRenderFns } from "./BasicPage.vue?vue&type=template&id=39c15c74&scoped=true"
import script from "./BasicPage.vue?vue&type=script&lang=js"
export * from "./BasicPage.vue?vue&type=script&lang=js"
import style0 from "./BasicPage.vue?vue&type=style&index=0&id=39c15c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c15c74",
  null
  
)

export default component.exports